module.exports = __webpack_public_path__ + "Icon-upload-img.png";